import { createApp } from 'vue/dist/vue.esm-bundler.js';
import BookSearchComponent from './components/BookSearchComponent.vue';

// Initialize Vue app when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  // Initialize book search
  const bookSearchContainer = document.getElementById('book-search-app');
  if (bookSearchContainer) {
    createApp(BookSearchComponent, {
      postType: 'book',
      placeholder: 'Søg efter bøger...',
      apiEndpoint: '/wp-json/alpha/v1/search-books',
    }).mount('#book-search-app');
  }

  // Initialize author search
  const authorSearchContainer = document.getElementById('author-search-app');
  if (authorSearchContainer) {
    createApp(BookSearchComponent, {
      postType: 'authors',
      placeholder: 'Søg efter forfattere...',
      apiEndpoint: '/wp-json/alpha/v1/search-authors',
    }).mount('#author-search-app');
  }
});

